module.exports = __webpack_public_path__ + "static/media/gallery04.e041339e.png";